import { createSelector } from 'reselect';
import selectShop from '../../selectors/select-shop';

export const getShopUi = createSelector(selectShop, ({ ui }) => ui || {});

export const getIsAddToCartModalOpen = createSelector(
  getShopUi,
  ({ isAddToCartModalOpen }) => isAddToCartModalOpen,
);

export const getIsDialogOpen = createSelector(getShopUi, ({ isModalOpen }) => isModalOpen);
